import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "column"
    },
    titleContainer: {
        flexDirection: "column"
    },
    tabsContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    contentContainer: {
        flex: 1
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
